export const trackEvent = (action, name, params = {}) => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
        return;
    }

    window.gtag(action, name, params);
};
